import React from "react";
import NavigationBtns from "./Navigation-btns";
import SimpleReactLightbox, { SRLWrapper } from "simple-react-lightbox";

const FirebaseSetup = () => {
  return (
    <div
      className="introduction "
      data-aos="fade-right"
      data-aos-delay="300"
      data-aos-duration="1000"
    >
      <h1 className="title">Firebase</h1>
      <p className="inner-text">
        We use Firebase Authentication, Cloud Messaging and Firestore in
        Foodyman. So, you have to setup Firebase in order to use Foodyman
        properly.
      </p>
      <div className="mt-4" />
      <div className="iframe-wrapper">
        <iframe
          width="560"
          height="315"
          src="https://www.youtube.com/embed/OLwNp_e5bxM"
          title="Firebase configuration"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
        ></iframe>
      </div>
      <div className="mt-4" />
      <div className="iframe-wrapper">
        <iframe
          width="560"
          height="315"
          src="https://www.youtube.com/embed/jCgZZiz1480"
          title="How to run connect firebase to project"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
        ></iframe>
      </div>

      <div className="mt-4" />
      <div className="iframe-wrapper">
        <iframe
          width="560"
          height="315"
          src="https://www.youtube.com/embed/5HzrGiY9cFo"
          title="Firebase auth configuration"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
        ></iframe>
      </div>
      <div className="mt-4" />
      <div className="iframe-wrapper">
        <iframe
          width="560"
          height="315"
          src="https://www.youtube.com/embed/cchc8T1QnCE?si=RvYlapwJ2S-oMd0h"
          title="Cloud messaging"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
        ></iframe>
      </div>
      <div className="">
        <p style={{ margin: "10px" }}>
          Add downloaded file to backend_folder/storage/app and run the command
          php artisan storage:link if you haven’t run it before
        </p>
        <img
          src={`../assets/img/google-service-json.jpg`}
          alt="icon"
          style={{ width: "100%" }}
        />
      </div>
      <div className="mt-4" />
      <div className="iframe-wrapper">
        <iframe
          width="560"
          height="315"
          src="https://www.youtube.com/embed/29ARDVIXvXk"
          title="Firestore"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
        ></iframe>
      </div>
      <div className="mt-4" />
      <div className="iframe-wrapper">
        <iframe
          width="560"
          height="315"
          src="https://www.youtube.com/embed/29ARDVIXvXk"
          title="Firestore"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
        ></iframe>
      </div>
      <div className="ptf-spacer" style={{ "--ptf-xxl": "3.75rem" }}></div>
      <h2 className="title">Firebase configuration in the admin panel</h2>
      <p className="inner-text">
        The same Firebase web SDK credentials you placed in the
        storefront&apos;s <code>.env</code> must also be entered in the admin
        panel so that the backend can deliver push notifications. This is a
        separate, one-time step performed from the admin UI.
      </p>
      <p style={{ marginBottom: 0 }}>
        1. Sign in to the <strong>admin panel</strong>.
      </p>
      <p style={{ marginBottom: 0 }}>
        2. Open <strong>Notification settings</strong> &rarr;{" "}
        <strong>Firebase configuration</strong>.
      </p>
      <p style={{ marginBottom: 0 }}>
        3. Fill in every field with the matching value from your Firebase
        project (<code>apiKey</code>, <code>authDomain</code>,{" "}
        <code>projectId</code>, <code>storageBucket</code>,{" "}
        <code>messagingSenderId</code>, <code>appId</code>,{" "}
        <code>measurementId</code>, <code>vapidKey</code>).
      </p>
      <p>
        4. Save the form. The values must match the ones in the
        storefront&apos;s <code>.env</code> and{" "}
        <code>public/firebase-messaging-sw.js</code> exactly &mdash; any
        mismatch will break push notifications.
      </p>
      <div className="introduction-img-container">
        <SimpleReactLightbox>
          <SRLWrapper>
            <a
              href="/assets/img/doc/quick-admin-firebase-config.png"
              data-fancybox
              rel="nofollow"
            >
              <img
                src="/assets/img/doc/quick-admin-firebase-config.png"
                alt="Admin panel — Notification settings — Firebase configuration"
                loading="lazy"
                className="img-responsive-full"
              />
            </a>
          </SRLWrapper>
        </SimpleReactLightbox>
      </div>
      <div className="ptf-spacer" style={{ "--ptf-xxl": "3.75rem" }}></div>
      <h2 className="title">Authorized domains for Google sign-in</h2>
      <p className="inner-text">
        Firebase Authentication only allows the OAuth sign-in flow (Google,
        Facebook, etc.) to run from domains explicitly added to the{" "}
        <strong>Authorized domains</strong> list of your project. If your
        production domain is missing, the Google sign-in popup will fail with an{" "}
        <em>auth/unauthorized-domain</em> error.
      </p>
      <p>
        Open the{" "}
        <a
          href="https://console.firebase.google.com/"
          target="_blank"
          rel="noreferrer"
        >
          Firebase Console
        </a>{" "}
        and follow the steps below to add your website&apos;s domain:
      </p>
      <p style={{ marginBottom: 0 }}>
        1. Select your project &rarr; <strong>Security</strong> &rarr;{" "}
        <strong>Authentication</strong>.
      </p>
      <p style={{ marginBottom: 0 }}>
        2. Switch to the <strong>Settings</strong> tab and open{" "}
        <strong>Authorized domains</strong>.
      </p>
      <p style={{ marginBottom: 0 }}>
        3. Click <strong>Add domain</strong> and enter your production hostname
        (e.g. <code>your-domain.com</code>). Do not include the protocol or a
        trailing slash.
      </p>
      <p>
        4. Repeat for every additional domain that should serve the site
        (staging, preview deployments, custom subdomains).
      </p>
      <div className="alert alert-primary mt-3" role="alert">
        <strong>Note:</strong> <code>localhost</code> is authorized by default,
        so local development works out of the box. You only need to add real
        domains used in production or staging.
      </div>
      <div className="introduction-img-container">
        <SimpleReactLightbox>
          <SRLWrapper>
            <a
              href="/assets/img/doc/quick-authorized-domains.png"
              data-fancybox
              rel="nofollow"
            >
              <img
                src="/assets/img/doc/quick-authorized-domains.png"
                alt="Firebase Authentication authorized domains"
                loading="lazy"
                className="img-responsive-full"
              />
            </a>
          </SRLWrapper>
        </SimpleReactLightbox>
      </div>
      <div className="ptf-spacer" style={{ "--ptf-xxl": "3.75rem" }}></div>
      <NavigationBtns />
    </div>
  );
};

export default FirebaseSetup;
